/* Register the service worker only in production builds.
 *
 * In development (CRA's `yarn start`), every code change produces a new
 * bundle which would trigger SW update events on every save — and a
 * naive "auto-reload on update" handler causes an infinite refresh loop.
 * So in dev we proactively *unregister* any SW that may have been
 * installed during a previous session and clear its caches, to make sure
 * the user is never stuck on a stale installation.
 */
export function registerServiceWorker() {
  if (typeof window === "undefined") return;
  if (!("serviceWorker" in navigator)) return;

  const isProd = process.env.NODE_ENV === "production";

  if (!isProd) {
    // Belt-and-suspenders cleanup: nuke any SW + caches a previous
    // dev/prod session may have left behind.
    navigator.serviceWorker.getRegistrations().then((regs) => {
      regs.forEach((r) => r.unregister().catch(() => {}));
    }).catch(() => {});
    if (typeof caches !== "undefined") {
      caches.keys().then((keys) => keys.forEach((k) => caches.delete(k))).catch(() => {});
    }
    return;
  }

  if (!window.isSecureContext) return;

  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/sw.js", { scope: "/", updateViaCache: "none" })
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.warn("ServiceWorker registration failed:", err);
      });
  });
}
